import { render, staticRenderFns } from "./ProfessionalPanelV2026.vue?vue&type=template&id=096728f5&scoped=true"
import script from "./ProfessionalPanelV2026.vue?vue&type=script&lang=js"
export * from "./ProfessionalPanelV2026.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalPanelV2026.vue?vue&type=style&index=0&id=096728f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096728f5",
  null
  
)

export default component.exports